(function () {
  const initFaq = (root) => {
    root.querySelectorAll('details.amure-ship-faq__item').forEach((item) => {
      if (item.dataset.bound === 'true') return;
      item.dataset.bound = 'true';
      item.addEventListener('toggle', () => {
        if (!item.open) return;
        root.querySelectorAll('details.amure-ship-faq__item[open]').forEach((other) => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  };

  const initReveal = (root) => {
    const els = root.querySelectorAll('.amure-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -32px 0px' }
    );

    els.forEach((el) => io.observe(el));
  };

  const init = (root) => {
    initFaq(root);
    initReveal(root);
  };

  const boot = () => {
    document.querySelectorAll('[data-amure-shipping], [data-amure-policy], [data-amure-contact], [data-amure-cookies]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-amure-shipping], [data-amure-policy], [data-amure-contact], [data-amure-cookies]');
    if (root) init(root);
  });
})();
